module.exports = __webpack_public_path__ + "static/media/logo.7011d14c.png";